var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image"},[(_vm.value && _vm.usage === 'verification')?_c('image-preview',{attrs:{"preview":_vm.value},on:{"close":function($event){return _vm.$emit('input', null)}}}):_c('div',[_c('input',{attrs:{"type":"file","accept":"images/*"},on:{"change":_vm.upload}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }